import { getFromBreakpoint, getUpToBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles<void>()((theme) => ({
	wrapper: {
		marginTop: theme.spacing.small,

		[getFromBreakpoint('md')]: {
			[getUpToBreakpoint('lg')]: {
				textAlign: 'center',
			},
		},
	},
}));
